export const toBase64Url = x =>
  btoa(x).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '')

export const fromBase64Url = x =>
  atob(
    x
      .replaceAll('-', '+')
      .replaceAll('_', '/')
      .padEnd(x.length + ((4 - (x.length % 4)) % 4), '=')
  )
